import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  header: {
    zIndex: theme.zIndex.page?.header,
    [theme.breakpoints.down("xs")]: {
      top: 0
    }
  },
  topBar: {
    minHeight: 56,
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
    borderRadius: 0,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      paddingLeft: 8,
      paddingRight: 8,
      minHeight: "56px"
    }
  },
  topBarItem: {
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      flexBasis: "30%"
    }
  },
  leftItem: {},
  centerItem: {},
  rightItem: {
    textAlign: "right"
  },
  hiddenItem: {
    visibility: "hidden"
  },
  icon: {},
  resetButton: {
    borderRadius: 4
  },
  resetButtonTitle: {
    fontSize: 16,
    marginLeft: 18,
    fontWeight: 600,
    color: "inherit",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("md")]: {
      marginLeft: 4,
      fontSize: 14
    }
  },
  resetButtonLabel: {
    alignItems: "center"
  },
  title: {
    fontSize: 18,
    color: theme.palette.text.primary,
    textAlign: "center",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: 1.2
  },
  name: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    lineHeight: "normal",
    textAlign: "center"
  }
}));
